export default __webpack_public_path__ + "static/media/spotify.a7d33a36.png";